import api from '@/lib/api';
import type { AdminHotLead } from '@/types/admin';

export async function fetchHotLeads(): Promise<AdminHotLead[]> {
  const { data } = await api.get('/admin/intents/hot-leads');
  const body = data as { data?: AdminHotLead[] } | AdminHotLead[];
  return Array.isArray(body) ? body : body.data ?? [];
}
